import { instance, config } from './axios.js'
import siteConfig from "../config.js";
const NODE_ENV = process.env.NODE_ENV
const apiConfig = () => {
  return config(siteConfig[NODE_ENV]['apiPrefix'])
}
export default {
  getHeader() {
    return apiConfig();
  },
  doReg(data) {
    return instance.post("/user/addUser", data, apiConfig());
  },
  logout(data) {
    return instance.post("/user/logout", data, apiConfig());
  },
  auth(data) {
    return instance.post("/auth/token", data, apiConfig());
  },
  doLogin(data) {
    return instance.post("/auth/local", data, apiConfig());
  },
  forgotPassword(data) {
    return instance.post("/user/forgotPassword", data, apiConfig());
  },
  resetPassword(data) {
    return instance.post("/user/resetPassword", data, apiConfig());
  },
  updateUser(data) {
    return instance.put("/user/updateUser", data, apiConfig());
  },
  checkUserExist(data) {
    return instance.post("/user/checkExist", data, apiConfig());
  },
  upload(data) {
    return instance.post("/uploader/upload", data, apiConfig());
  },
  delBook(id) {
    return instance.delete("/article/delete/" + id, apiConfig());
  },
  publishBook(data) {
    return instance.post("/article/addBook", data, apiConfig());
  },
  publishArticle(data) {
    return instance.post("/article/publishArticle", data, apiConfig());
  },
  updateArticle(data) {
    return instance.put("/article/updateArticle", data, apiConfig());
  },
  updateBook(data) {
    return instance.put("/article/updateBook", data, apiConfig());
  },
  getContentById(id) {
    return instance.get("/article/getContentById/" + id, apiConfig());
  },
  getBookByCode(query) {
    return instance.get(
      "/article/getBookByCode/" + query.username + "/" + query.code,
      apiConfig()
    );
  },
  updateBookCode(data) {
    return instance.put("/article/updateBookCode", data, apiConfig());
  },
  articleListByBookId(id, limit = 0, skip = 0) {
    return instance.get(
      `/article/articleListByBookId/${id}?limit=${limit}&skip=${skip}`,
      apiConfig()
    );
  },
  getArticleList(type, limit = 0, skip = 0) {
    return instance.get(
      `/article/articleList/${type}?limit=${limit}&skip=${skip}`,
      apiConfig()
    );
  },
  getArticleListByEventName(id, limit = 0, skip = 0) {
    return instance.get(
      `/article/getArticleListByEventName/${id}?limit=${limit}&skip=${skip}`,
      apiConfig()
    );
  },
  getBookList({ type, limit = 0, skip = 0, isPrivate = "" }) {
    return instance.get(
      `/article/bookList/${type}?limit=${limit}&skip=${skip}&isPrivate=${isPrivate}`,
      apiConfig()
    );
  },
  checkNewBook(type = "public", lastest) {
    if (!lastest) throw new Error("missing lastest time");
    return instance.get(
      `/article/bookList/new/${type}?lastest=${lastest}`,
      apiConfig()
    );
  },
  verfiyPassword(data) {
    return instance.post("/article/verfiyPassword/", data, apiConfig());
  },
  bookOptions(data) {
    return instance.post("/article/bookOptions/", data, apiConfig());
  },
  addToFavorite(data) {
    return instance.post("/favorite/addToFavorite/", data, apiConfig());
  },
  unFavorite(data) {
    return instance.post("/favorite/unFavorite/", data, apiConfig());
  },
  resendActiveEmail(data) {
    return instance.post("/user/resendActiveEmail/", data, apiConfig());
  },
  emailActivation(data) {
    return instance.post("/user/emailActivation/", data, apiConfig());
  },
  skipActivation(data) {
    return instance.post("/user/skipEmailActivation/", data, apiConfig());
  },
  updateProfile(data) {
    return instance.post("/user/updateProfile/", data, apiConfig());
  },
  publishComment(data) {
    return instance.post("/comment/addComment/", data, apiConfig());
  },
  commentList(aid, limit = 0, skip = 0) {
    return instance.get(
      `/comment/commentList/${aid}?limit=${limit}&skip=${skip}`,
      apiConfig()
    );
  },
  getCommentById(id) {
    return instance.get(`/comment/getCommentById/${id}`, apiConfig());
  },
  delComment(id) {
    return instance.delete("/comment/" + id, apiConfig());
  },
  createLink(data) {
    return instance.post("/link/createLink", data, apiConfig());
  },
  getEventList({ type = 'all', limit = 0, skip = 0 } = {}) {
    return instance.get(`/event/getEventList/${type}?limit=${limit}&skip=${skip}`, apiConfig());
  },
  getEvent(name) {
    return instance.get("/event/getEvent/" + name, apiConfig());
  },
  googleOauth(data) {
    return instance.post("/auth/providers/google", data, apiConfig());
  },
  getNoticeList(type) {
    return instance.get("/notice/" + type, apiConfig());
  },
  handleNotice(data) {
    return instance.put("/notice/handleNotice", data, apiConfig());
  },
  hideNotice(data) {
    return instance.put("/notice/handleNotice", data, apiConfig());
  },
  getBookCode(id) {
    return instance.get("/article/getBookCode/" + id, apiConfig());
  },
  getFileInfoById(id) {
    return instance.get("/uploader/getFile/" + id, apiConfig());
  },
  getPolicy(data) {
    return instance.post(`/uploader/getPolicy`, data, apiConfig());
  },
  saveFileToDb(data) {
    return instance.post(`/uploader/saveFileToDb`, data, apiConfig());
  },
  unSticky(data) {
    return instance.put(`/article/unSticky`, data, apiConfig());
  },
  setSticky(data) {
    return instance.put(`/article/setSticky`, data, apiConfig());
  },
  getRandomCover() {
    return instance.get("/article/getRandomCover/", apiConfig());
  },
  getContactList() {
    return instance.get("/user/getContactList/", apiConfig());
  },
  addContact(data) {
    return instance.post("/user/addContact/", data, apiConfig());
  },
  resetPasswordDecode(data) {
    return instance.post("/user/resetPasswordDecode", data, apiConfig());
  },
  bookInvite(data) {
    return instance.post("/task/bookInvite/", data, apiConfig());
  },
  removeBookInvite(data) {
    return instance.post("/task/removeBookInvite/", data, apiConfig());
  },
  getInvites(data) {
    return instance.get("/task/getInvites/", data, apiConfig());
  },
  getUserInfo(email) {
    return instance.get("/user/userInfo/" + email, apiConfig());
  },
  getInviteList(id) {
    return instance.get("/article/getInviteList/" + id, apiConfig());
  },
  getBookQrcode(id) {
    return instance.get("/article/getBookQrcode/" + id, apiConfig());
  },
  proxyImage(data) {
    return instance.post("/uploader/proxyImage/", data, apiConfig());
  },
  createUniqueLink(data) {
    return instance.post("/link/createUniqueLink/", data, apiConfig());
  },
  getEventUniqueLinks(id) {
    return instance.get("/link/getEventUniqueLinks/" + id, apiConfig());
  },
  addArticleUnconditional(data) {
    return instance.post("/article/addArticleUnconditional/", data, apiConfig());
  }

};
